import AWS from "aws-sdk";
AWS.config.update({
    accessKeyId: process.env.REACT_APP_AWS_KEY,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_KEY,
    region: "us-east-1"
});

export const dataURItoBlob = (dataURI) => {
    // convert base64/URLEncoded data component to raw binary data held in a string
    var byteString;
    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
        byteString = atob(dataURI.split(',')[1]);
    }
    else {
        byteString = unescape(dataURI.split(',')[1]);
    }
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to a typed array
    var ia = new Uint8Array(byteString.length);
    for (var i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ia], { type: mimeString });
}

export const uploadPhoto = async data => {
    const imageContent = dataURItoBlob(data.image);
    const s3Bucket = new AWS.S3({ params: { Bucket: "wesolv-assets" } });
    let s3data = {
        Key: data.fileKey,
        Body: imageContent,
        ContentType: data.image.split(',')[0].split(':')[1].split(';')[0],
        ACL: "public-read"
    };
    return s3Bucket.putObject(s3data).promise();
};


// WEBPACK FOOTER //
// ./src/utils/image.js